<template>
  <!-- Tarjeta del Resumen: cabecera (título + chip de fuente + extras) y cuerpo por slot. -->
  <div class="summary-card" :class="{ amber: mark && mode }">
    <div class="summary-card-head">
      <slot name="icon"></slot>
      <span class="summary-card-title">{{ title }}</span>
      <source-chip v-if="mode && chip" :source="chip"></source-chip>
      <span v-if="subtitle" class="summary-card-sub">{{ subtitle }}</span>
      <span v-else class="summary-card-spacer"></span>
      <slot name="extra"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  import SourceChip from './source-chip.vue'

  export default {
    name: 'PrmSummaryCard',

    components: { SourceChip },

    props: {
      title: { type: String, required: true },
      mode: { type: Boolean, default: false }, // modo "Fuente de datos"
      mark: { type: Boolean, default: false }, // tarjeta sin fuente: bandera/contorno ámbar en modo
      chip: { type: String, default: '' },     // fuente del chip de cabecera ('' = sin chip)
      subtitle: { type: String, default: '' }, // subtítulo bajo la cabecera ('' = sin subtítulo)
    },
  }
</script>

<style lang="scss" scoped>
  .summary-card { background: #fff; border: 1px solid #d4dae3; border-radius: 6px; overflow: hidden; }
  .summary-card-head {
    display: flex; align-items: center; flex-wrap: wrap; gap: 4px 6px;
    background: #e8eef5; border-bottom: 1px solid #c9d5e3; box-shadow: inset 3px 0 0 0 #3a6bc8;
    padding: 5px 10px; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: #1e3046;
  }
  // Subtítulo inline junto al título (tras el badge de fuente): minúsculas, gris, sin negrita.
  .summary-card-sub {
    font-size: 10px; font-weight: 400; text-transform: none; letter-spacing: 0; color: #7a8798;
    flex: 1 1 auto; min-width: 0;
  }
  // Empuja los extras (botones Añadir/Editar) a la derecha cuando la tarjeta no tiene subtítulo.
  .summary-card-spacer { flex: 1 1 auto; }
  .summary-card.amber { border-color: #e0b52a; }
  .summary-card.amber .summary-card-head {
    background: #fff4d6; color: #8a6d00; border-bottom-color: #ecd48a; box-shadow: inset 3px 0 0 0 #e0b52a;
  }
</style>
